module.exports = __webpack_public_path__ + "static/media/Icon Info.6a4865b5.svg";